 
import { Vue, Component } from "vue-property-decorator";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { ListDataSource } from "@/data/List/ListDataSource";
import draggable from "vuedraggable";
import { sortByPriorityDesc } from "@/cms-services/consts";
import ParamItems from "./compnents/param-items.vue"
@Component({
    components: {
        draggable,
        ParamItems
    }
})
export default class Home extends Vue {
    loaded: boolean = false;
    dataSource: ObjectDataSource = new ObjectDataSource({
        config: {},
        id: +this.$route.params.id,
        className: "LeadClass",
    });

    listDataSource: ListDataSource = new ListDataSource({
        config: {
            pageIndex: 1,
            pageSize: 1000,
        },
        className: "LeadClassParam",
    });
    $message: any;


    isMultiple(param: any) {
        return [
            "array",
            "enum",
            "color"
        ].includes(param.editor);
    }


    get breadcrumbs() {
        return [
            {
                text: "Главная",
                to: "/",
            },
            {
                text: "Классы лида",
                to: "/manage/crm/lead-class",
            },
            {
                text: this.dataSource.model?.caption,
                disabled: true,
            },
        ];
    }

    editors = [
        {
            'id': 'string',
            'caption': 'Строка'
        },
        {
            'id': 'text',
            'caption': 'Текст'
        },
        {
            'id': 'number',
            'caption': 'Число'
        },
        {
            'id': 'bool',
            'caption': 'Булевое значение'
        },
        {
            'id': 'dateTime',
            'caption': 'Дата и время'
        },
        {
            'id': 'enum',
            'caption': 'Выбор 1 элемента из списка'
        },
        {
            'id': 'array',
            'caption': 'Выбор нескольких элементов из списка'
        },
        {
            'id': 'color',
            'caption': 'Выбор цвета'
        }
    ]


    async add() {
        await this.listDataSource.add({
            leadClassId: this.dataSource.model.id,
            caption: "Новый параметр " + this.listDataSource.items.length,
            description: "Описание параметра",
        });
    }

    async remove(param:any){
        
        if(param.items.length > 0){
            this.$message("Удалите значения параметра","error")
            return;
        }
        await this.listDataSource.remove(param.id)

    }


    async mounted() {
        await this.dataSource.get();
        this.listDataSource.items = this.dataSource.model.params.sort(sortByPriorityDesc) ?? [];
        this.loaded = true; 
    }
   
}
